// docs: https://github.com/altostra/type-validations#readme
import { recordOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isEngagementContentBlocksContentResult = recordOf({
  value: string,
});
